function PhotoCompetitionModal(el) {
    this.el = el;

    this.innerEl = this.el.querySelector('.jsPhotoCompetitionModalInner');
    this.contentEl = this.el.querySelector('.jsContent');
    this.focusedElBeforeOpen = null;
    this.focusableEls = this.el.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    this.firstFocusableEl = this.focusableEls[0];
    this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];
    this.voteFormTriggerEl = this.el.querySelector('.jsVoteFormTrigger');
    this.voteFormEl = this.el.querySelector('.jsVoteForm');
    this.voteFormInputEl = this.voteFormEl ? this.voteFormEl.querySelector('input') : null;
    this.formSuccessEl = this.el.querySelector('.jsFormSuccess');
    this.formErrorEl = this.el.querySelector('.jsFormError');
    this.content = {};

    this.el.addEventListener('click', e => {
        if (e.target.classList.contains('jsCloseModal')) this.hide();
    });

    window.addEventListener('keyup', e => {
        if (e.key.toLowerCase() === 'escape') this.hide();
    });

    window.addEventListener('keydown', e => {
        const tabIsPressed = e.key === 'Tab';

        if (!tabIsPressed) return;

        if (e.shiftKey) {
            if (document.activeElement === this.firstFocusableEl) {
                this.lastFocusableEl.focus();
                e.preventDefault();
            }
        }
        else {
            if (document.activeElement === this.lastFocusableEl) {
                this.firstFocusableEl.focus();
                e.preventDefault();
            }
        }
    });

    if (this.voteFormTriggerEl) {
        this.voteFormTriggerEl.addEventListener('click', e => {
            e.preventDefault();
            this.focusVoteFormInput();
        });
    }

    if (this.voteFormEl) {
        this.voteFormEl.addEventListener('submit', e => {
            e.preventDefault();

            const email = this.voteFormInputEl.value.trim();

            if (! email) {
                alert('Vul een e-mailadres in.');
                this.focusVoteFormInput();
                return;
            }

            this.el.classList.add('loading');

            se_postRequest(se_ajax.ajaxurl, {
                action: 'send_photo_competition_vote',
                email: email,
                photo_id: this.content.photo_id,
                category: this.content.category_slug
            }, response => {
                this.el.classList.remove('loading');
                const data = JSON.parse(response);

                if (data.success) {
                    this.hideError();
                    this.el.classList.add('success');
                    this.voteFormEl.style.display = 'none';
                }
                else {
                    this.el.classList.add('error');
                    this.displayError(data.message);
                }
            }, () => {
                this.el.classList.remove('loading');
                this.el.classList.add('error');
                this.displayError('general-error');
            });
        });
    }
}

PhotoCompetitionModal.prototype.focusVoteFormInput = function() {
    this.voteFormInputEl.focus();
};

PhotoCompetitionModal.prototype.displayError = function(errorCode) {
    const errorMessages = {
        'enter-valid-email': 'Vul een geldig e-mailadres in.',
        'already-voted-in-this-category': 'Je hebt al gestemd in deze leeftijdsgroep.',
        'failed-to-send-vote': 'Het versturen van je stem is mislukt. Probeer het opnieuw.',
        'general-error': 'Er is een fout opgetreden. Probeer het opnieuw.'
    };

    const message = errorMessages[errorCode] || errorMessages['general-error'];

    if (this.formErrorEl) {
        this.formErrorEl.textContent = message;
        this.formErrorEl.style.display = 'block';
    }
};

PhotoCompetitionModal.prototype.hideError = function() {
    if (this.formErrorEl) {
        this.formErrorEl.style.display = 'none';
    }
};

PhotoCompetitionModal.prototype.resetForm = function() {
    this.el.classList.remove('success', 'error', 'loading');
    if (this.voteFormInputEl) this.voteFormInputEl.value = '';
    if (this.voteFormEl) this.voteFormEl.style.display = '';

    this.hideError();
};

PhotoCompetitionModal.prototype.show = function(focusInput = false) {
    if (this.el.classList.contains('show')) return;

    // Hide any previous error messages
    this.hideError();

    // Animation
    gsap.timeline()
        .set(this.el, { display: 'flex', opacity: 0 })
        .set(this.innerEl, { y: 20, opacity: 0 })

        .to(this.el, { duration: 0.5, y: 0, opacity: 1, ease: 'power2.inOut' })
        .to(this.innerEl, { duration: 0.5, y: 0, opacity: 1, ease: 'power2.inOut' }, '-=0.5')

        .add(_ => {
            this.el.classList.add('show');

            setTimeout(_ => {
                if (focusInput) this.focusVoteFormInput();
                else this.el.querySelector('.jsCloseModal').focus()
            }, 200);
        })
        .set(this.el, { clearProps: 'all' })
    ;

    // Prevent overflow on the HTML and body
    document.documentElement.classList.add('no-overflow');
    document.body.classList.add('no-overflow');

    // Accessibility stuff
    this.focusedElBeforeOpen = document.activeElement;
    this.firstFocusableEl.focus();
    document.body.ariaHidden = true;
    this.el.ariaHidden = false;
};

PhotoCompetitionModal.prototype.hide = function() {
    // Animation
    gsap.timeline()
        .to(this.el, 0.5, { opacity: 0, ease: 'power2.inOut' })
        .to(this.innerEl, { y: 20, opacity: 0, ease: 'power2.inOut' }, '-=0.5')

        .add(_ => {
            this.el.classList.remove('show');
            if (this.focusedElBeforeOpen) this.focusedElBeforeOpen.focus();
            this.focusedElBeforeOpen = null;
        })
    .set(this.el, { clearProps: 'all' });

    document.documentElement.classList.remove('no-overflow');
    document.body.classList.remove('no-overflow');

    // Reset form and states
    this.resetForm();

    // Accessibility stuff
    if (this.focusedElBeforeOpen) this.focusedElBeforeOpen.focus();
    document.body.ariaHidden = false;
    this.el.ariaHidden = true;
};

PhotoCompetitionModal.prototype.setContent = function(content) {
    this.content = content;
    this.el.querySelector('.jsImg').src = content.photo_img_url;
    this.el.querySelector('.jsUserName').textContent = content.user_name;
    this.el.querySelector('.jsCategory').textContent = `Categorie: ${content.category}`;
    this.el.querySelector('.jsPhotoName').textContent = `‘${content.photo_name}’`;
    this.el.querySelector('.jsDescription').innerHTML = content.photo_description;
};

(function() {
    // Only initialize if there are photo competition modal triggers on the page
    const triggerEls = document.querySelectorAll('[data-photo-competition-modal-trigger]');

    if (triggerEls.length > 0) {
        const photoCompetitionModalEl = document.querySelector('.jsPhotoCompetitionModal');

        if (photoCompetitionModalEl) {
            const photoCompetitionModal = new PhotoCompetitionModal(photoCompetitionModalEl);

            triggerEls.forEach(triggerEl => {
                triggerEl.addEventListener('click', e => {
                    e.preventDefault();

                    // Get photo info from data attribute
                    const photoInfo = JSON.parse(triggerEl.getAttribute('data-photo-info'));
                    if (photoInfo) photoCompetitionModal.setContent(photoInfo);

                    photoCompetitionModal.show(triggerEl.getAttribute('data-photo-competition-modal-trigger') === 'vote');
                });
            });
        }
    }
})();